import { z } from "zod";
import { MiContentDrawer, MiDetailFields } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  INPUT_TYPES,
} from "@miplatform/constants";
import { useEdit } from "@miplatform/hooks";
import { mdiAccountOutline } from "@mdi/js";
import { Box } from "@mui/material";

export function AddVendorDrawer({
  supplierAccounts = [],
  isLoading,
  open,
  onClose,
  onSave,
}) {
  const INITIAL_VALUES = {
    accountId: "",
  };

  const edit = useEdit(INITIAL_VALUES, [
    {
      name: "accountId",
      validationRule: z.string().min(1),
    },
  ]);

  const addVendorModalFields = [
    {
      label: "Supplier Account",
      name: "accountId",
      fieldType: INPUT_TYPES.SELECT,
      options: supplierAccounts.map((account) => ({
        value: account.id,
        label: `${account.name}${
          !account.supplierType ? "" : ` (${account.supplierType})`
        }`,
      })),
      handleChange: (event) => {
        edit.update({ accountId: event.target.value });
      },
      required: true,
    },
  ];

  const handleSubmit = async () => {
    await onSave({
      data: {
        accountId: edit.getValue("accountId"),
      },
    });
    edit.reset();
    onClose();
  };

  return (
    <MiContentDrawer
      open={open}
      isLoading={isLoading}
      variant="temporary"
      width={500}
      leftIcon={mdiAccountOutline}
      title="Add Supplier"
      onClose={() => {
        edit.reset();
        onClose();
      }}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          size: "medium",
          color: BUTTON_COLORS.BLACK,
          onClick: () => {
            edit.reset();
            onClose();
          },
        },
        {
          name: "Add Supplier",
          variant: BUTTON_VARIANTS.CONTAINED,
          size: "medium",
          disabled: !edit.isValid() || !edit.isDirty(),
          color: BUTTON_COLORS.PRIMARY,
          onClick: handleSubmit,
        },
      ]}
    >
      <Box flex={1} p={2}>
        <MiDetailFields detailFields={addVendorModalFields} edit={edit} />
      </Box>
    </MiContentDrawer>
  );
}
